import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import omit from 'lodash/omit';
import styles from './styles.scss.js';

var GridItem = function GridItem(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var responsiveProps = ['col', 'xsCol', 'smCol', 'mdCol', 'lgCol', 'xlgCol', 'xxlgCol', 'row', 'xsRow', 'smRow', 'mdRow', 'lgRow', 'xlgRow', 'xxlgRow'];
  var responsiveClassNames = responsiveProps.map(function (propName) {
    var propValue = rest[propName];
    var className = styles["" + propName + rest[propName]];

    if (propValue !== undefined && !className) {
      console.warn("<GridItem " + propName + "=\"" + propValue + "\" />: \"" + propValue + "\" is not a valid value for \"" + propName + "\"");
    }

    return className;
  });
  return React.createElement("div", __assign({
    className: classnames(styles['grid-item-base'], className, responsiveClassNames)
  }, omit(rest, responsiveProps)));
};

export default GridItem;
//# sourceMappingURL=index.js.map
